import { ReactNode } from 'react'

import { Permission } from '@forto-dev/auth-sdk-models'
import { CustomerFeature } from '@forto-dev/customer-master-data-models'

import { useAuth } from '../api/useAuth'
import { customerHasFeature } from '../domain/customer'

interface AccessProps {
  permission: Permission
  feature?: CustomerFeature
  children: ReactNode
}

export function Access({ permission, feature, children }: AccessProps) {
  // Permissions come from the token, so there is no need to wait for the user to load
  const { customer, isReady, isCustomerActive, hasPermission } = useAuth()

  if (!isCustomerActive || !isReady || (feature && !customer)) {
    return null
  }

  const hasRequiredPermission = hasPermission(permission)

  // Check if customer has required feature (if feature check is needed)
  const hasRequiredFeature = !feature || (customer && customerHasFeature(customer, feature))

  const hasAccess = Boolean(hasRequiredPermission && hasRequiredFeature)

  return hasAccess ? children : null
}
